export const isDealModeSummaryPayloadCompatible = (
  summaryApplications?: any[]
): boolean => {
  if (!Array.isArray(summaryApplications)) {
    return false;
  }

  if (summaryApplications.length === 0) {
    // Empty payload can be transient/incomplete for non-empty deals.
    // Treat as incompatible so caller can use fallback fetch path.
    return false;
  }

  return summaryApplications.every((application) => {
    if (!application || typeof application !== "object") {
      return false;
    }

    const applicationSummary = application.applicationSummary;
    const hasValidApplicationSummary =
      applicationSummary &&
      typeof applicationSummary === "object" &&
      applicationSummary.id !== undefined &&
      applicationSummary.id !== null;

    return (
      Array.isArray(application.idVerifications) &&
      typeof application.dealDecisionIsMade === "boolean" &&
      typeof application.isPrimaryApplication === "boolean" &&
      typeof application.applicantVrn === "string" &&
      application.applicantVrn.length > 0 &&
      hasValidApplicationSummary
    );
  });
};

export const hasSummaryApplications = (
  summaryApplications?: any[]
): boolean => {
  return Array.isArray(summaryApplications) && summaryApplications.length > 0;
};

type SelectRawApplicationsArgs = {
  shouldUseFallback: boolean;
  summaryApplications?: any[];
  fullApplications?: any[];
};

export const selectRawApplications = ({
  shouldUseFallback,
  summaryApplications,
  fullApplications,
}: SelectRawApplicationsArgs): any[] => {
  if (
    shouldUseFallback &&
    Array.isArray(fullApplications) &&
    fullApplications.length > 0
  ) {
    return fullApplications;
  }

  return Array.isArray(summaryApplications) ? summaryApplications : [];
};

type ShouldBlockFallbackLoadingArgs = {
  shouldUseFallback: boolean;
  hasSummaryData: boolean;
  hasFallbackData: boolean;
  isFallbackLoading: boolean;
};

export const shouldBlockOnFallbackLoading = ({
  shouldUseFallback,
  hasSummaryData,
  hasFallbackData,
  isFallbackLoading,
}: ShouldBlockFallbackLoadingArgs): boolean => {
  // If summary data exists, render immediately and let fallback hydrate in background.
  if (hasSummaryData) {
    return false;
  }
  if (hasFallbackData) {
    return false;
  }

  return shouldUseFallback && isFallbackLoading;
};

// Any provider; one expired report hides all three background cards
export const hasExpiredBackgroundReports = (
  backgroundCreditCheck?: any
): boolean =>
  [
    backgroundCreditCheck?.creditScoreSummary,
    backgroundCreditCheck?.criminalRecords,
    backgroundCreditCheck?.evictionRecords,
  ].some((report) => report?.expired === true);
